const DEFAULT_COVERAGE_SETTINGS = Object.freeze({ minKPercent: 20, colorCoveragePercent: 15 });
function validateCoverageSettings(value) {
  const result = {};
  for (const key of Object.keys(DEFAULT_COVERAGE_SETTINGS)) {
    const number = value?.[key];
    if (
      typeof number !== "number" ||
      !Number.isFinite(number) ||
      number < 0 ||
      number > 100 ||
      Math.abs(number * 100 - Math.round(number * 100)) > 0.000001
    )
      throw Object.assign(
        new Error("Informe percentuais de 0 a 100, com até duas casas decimais."),
        { statusCode: 400 }
      );
    result[key] = number;
  }
  return result;
}
module.exports = { DEFAULT_COVERAGE_SETTINGS, validateCoverageSettings };
